import DixaIcon from '@dixa/dixa-modern-icons';
import { FlexBox, Icon, IconNames, Timestamp } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { NotificationT } from 'lib-shared-legacy-types';

import { ConversationStatusIcon } from '../../../conversation/components/conversationStatusIcon';

import styles from './notificationHistoryItem.module.scss';

type PropsT = {
  notification: NotificationT;
  className?: string;
};

export const NotificationHistoryItem = ({
  notification,
  className,
}: PropsT): JSX.Element => {
  const { conversation, status } = notification;
  let icon;
  let customTitle = '';
  const fixedIconName = notification.icon
    ? (notification.icon.replace(/^(i-)/, '') as IconNames)
    : notification.icon;

  const rootClass = classnames(
    {
      [styles.root]: styles.root,
      [styles.rootSuccess]: status === 'success',
      [styles.rootWarning]: status === 'warning',
      [styles.rootDanger]: status === 'danger',
    },
    className,
  );

  if (notification.icon) {
    icon = <Icon name={fixedIconName} size={24} />;
  }

  if (notification.type === 'rating-up') {
    customTitle = 'Positive rating';
    icon = <DixaIcon className={'circled bg-brand-b-0'} icon={'thumbs-up'} />;
  } else if (notification.type === 'rating-down') {
    customTitle = 'Negative rating';
    icon = <DixaIcon className={'circled bg-brand-c-0'} icon={'thumbs-down'} />;
  }

  return (
    <FlexBox className={rootClass}>
      <FlexBox
        alignItems="center"
        justifyContent="center"
        margin="0 300 0 0"
        className={styles.icon}
      >
        {conversation ? (
          <ConversationStatusIcon
            channel={conversation.channel}
            direction={conversation.direction}
            status={conversation.status}
            className="notification-item__icon"
          />
        ) : (
          <>{icon}</>
        )}
      </FlexBox>
      <FlexBox>
        <div>
          <h4 className={styles.title}>
            {customTitle ? customTitle : notification.title}
          </h4>
          <h6 className={styles.time}>
            <Timestamp time={notification.date} />
          </h6>
        </div>
      </FlexBox>
    </FlexBox>
  );
};
